export default "__VITE_ASSET__DShWOOqp__"